import React from 'react';
import LineChart, {chartContent} from "../../../../common/component/LineChart";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../../Common/util/ProcService";

const ThisYearSizeDashBoard: React.FC = () => {
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   ["ThisYearSizeDashBoardKey"];
    const { data } = useCommonUseQuery<chartContent[]>(
        queryKey,
        () =>procAdminService<chartContent[]>("post", `${serviceCode}ADS04`, null));

    const yearCategory = [
        '01','02','03','04',
        '05','06','07','08',
        '09','10','11','12',
    ]

    const yearSeries:chartContent[] = data ? data :
                                                    [
                                                        {
                                                            name: "2019년",
                                                            data: [
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                            ],
                                                        },
                                                        {
                                                            name: "2020년",
                                                            data: [
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                            ],
                                                        },
                                                        {
                                                            name: "2021년",
                                                            data: [
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                            ],
                                                        },
                                                        {
                                                            name: "2022년",
                                                            data: [
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                            ],
                                                        },
                                                        {
                                                            name: "2023년",
                                                            data: [
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                                0,0,0,0,
                                                            ],
                                                        },
                                                    ]


    return (
        <LineChart title="연도별 업로드 현황 - 최근5년 (용량-GB)" key={4} unit="GB" categories={yearCategory} series={yearSeries} dataLabels={true}/>
    );
};

export default ThisYearSizeDashBoard;
